import React from 'react';

export const tokenRouteConfig = [
  {
    routes: [
      {
        path: '/token/pause',
        component: React.lazy(() => import('./Pause/TokenPause')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/token/supply',
        component: React.lazy(() => import('./Supply/TokenSupply')),
      },
    ],
  },
];
